module.exports = __webpack_public_path__ + "static/Dathena-536431c1328b3c30333235a81ac88093.jpg";